import React from 'react';
import { EnumType } from 'json-to-graphql-query';
import { IONICWrapper, GeographicalService } from '../../../utils/common';
import { IRole, IAddress } from '../../../schemas/manage/manage.Schema';
import { ADMIN, BETA, GUEST, LEASED_ON_OWNER_OPERATOR_ROLE, PROFILE_FIELDS, ROLES, Roles } from '../../../utils/constants';
import { CustomModal } from '../../../components/CustomModal';
import { IonInput, IonItem, IonLabel } from '@ionic/react';
import MobileNumber from '../../../utils/MobileNumber/MobileNumber';
import { isElevatedLeasedOwenerOprRole, isElevatedLeasedOwenerOprRoleOnSelectedUser, isLeasedOwnerOprRoleOnly, isLeasedOwnerOprRoleOnlyOnSelectedUser } from '../../../utils/roleUtil/RoleUtil';

/**
 * Get Address List from Azure
 * @param value
 * @param callback
 */
export const fetchAddressList = async (value: any, callback: Function) => {
  if (value.length > 2) {
    await GeographicalService.details.searchAddress(value, (Locations: any) => {
      const list = Locations.map((item: any) => ({
        addressLine1: item.Address.StreetAddress || '',
        addressLine2: '',
        addressType: '',
        city: item.Address.City || '',
        state: item.Address.State || '',
        postalCode: item.Address.Zip || ''
      }));
      callback(list);
    });
  }
};

/**
 * Should Allow Alpha numberic text only
 * @param event
 */
export const handleAlphaNumeric = (value: string): string => {
  return (value && value.replace(/[^a-zA-Z0-9 ]*/g, '')) || '';
};

/**
 * Validate Phone Number
 * @param value
 */
export const handlePhoneNumber = (value: string): boolean => {
  return /^([0-9]{10})$/.test(value);
};

export const isValidString = (value: string): boolean => {
  return !/[~`!#@$%\^&*+=\\[\]\\';,/(){}|\\"\:<>\?]/g.test(value);
};

/**
 * Should allow only Numbers
 * @param event
 */
export const numberOnlyValidation = (value: string): string => {
  return (value && value.replace(/[^+0-9+]*/g, '')) || '';
};

/**
 * Format Phone Numbers
 * @param phone
 */
export const formatPhoneNumber = (phone: string, isCountryCode = false) => {
  const cleaned = `${phone}`.replace(/\D/g, '');
  const match = cleaned.match(/^(1|9|91|52)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? `+${match[1]}` : '';
    if (isCountryCode) {
      return [intlCode, ' ', match[2], '.', match[3], '.', match[4]].join('');
    }
    return [match[2], '.', match[3], '.', match[4]].join('');
  }
  return null;
};

/**
 * Remove Special Charters
 *
 * @param phone
 */
export const removeSpecial = (phone: string) => {
  let value = phone && phone.replace(/[^+0-9+]*/g, '');
  return '+1' + value;
};
export const removeSpecialProfile = (phone: string) => {
  let value = phone && phone.replace(/[^+0-9+]*/g, '');
  return  value;
};

export const rolesList = [
  { value: 'carrierGuest', name: 'Guest' },
  { value: 'carrierDriver', name: 'Driver' },
  { value: 'carrierDispatcher', name: 'Dispatcher' },
  { value: 'carrierAdmin', name: 'Admin' },
  { value: 'carrierBeta1', name: 'Beta' },
  { value: Roles.carrierLeasedOwnerOpr, name: LEASED_ON_OWNER_OPERATOR_ROLE }
];

export const roles: Array<IRole> = [
  {
    label: 'Driver',
    value: Roles.carrierDriver,
    desc: 'Carry and update the status of loads.',
    selected: false,
    displayFlag: true
  },
  {
    label: 'Dispatcher',
    value: Roles.carrierDispatcher,
    desc: 'Search, book, and manage the status of loads.',
    selected: false,
    displayFlag: true
  },
  {
    label: LEASED_ON_OWNER_OPERATOR_ROLE,
    value: Roles.carrierLeasedOwnerOpr,
    desc: 'Search, book, carry and update loads for themselves.',
    selected: false,
    displayFlag: true
  }
];

export const rolesForWeb: Array<IRole> = [
  {
    label: BETA,
    value: "carrierBeta1",
    desc: 'Tests and provides feedback for software in pre-launch',
    selected: false,
    displayFlag: false
  },
  {
    label: ADMIN,
    value: Roles.carrierAdmin,
    desc: 'Manages carrier user(s) roles and privileges.',
    selected: false,
    displayFlag: false
  },
  {
    label: GUEST,
    value: Roles.carrierGuest,
    desc: 'Limited access permissions',
    selected: false,
    displayFlag: false
  },
  {
    label: 'Driver',
    value: Roles.carrierDriver,
    desc: 'Carry and update the status of loads.',
    selected: false,
    displayFlag: true
  },
  {
    label: 'Dispatcher',
    value: Roles.carrierDispatcher,
    desc: 'Search, book, and manage the status of loads.',
    selected: false,
    displayFlag: true
  },
  {
    label: LEASED_ON_OWNER_OPERATOR_ROLE,
    value: Roles.carrierLeasedOwnerOpr,
    desc: 'Search, book, carry and update loads for themselves.',
    selected: false,
    displayFlag: true
  }
];

export const registrationroles: Array<IRole> = [
  {
    label: 'Driver',
    value: Roles.carrierDriver,
    desc: 'Carry and update the status of loads.',
    selected: false
  },
  {
    label: 'Dispatcher',
    value: Roles.carrierDispatcher,
    desc: 'Search, book, and manage the status of loads.',
    selected: false
  }
];

export const carrierField = {
  label: 'Carrier ID',
  name: 'carrierId',
  placeholder: 'Carrier Id',
  className: 'carrierId'
};

export const defaultForm = {
  userId: null,
  roles: '',
  firstName: '',
  lastName: '',
  email: '',
  mobileNumber: '',
  tractorNumber: '',
  addressDTOs: {
    addressLine1: '',
    addressLine2: '',
    addressType: '',
    city: '',
    state: '',
    postalCode: ''
  },
  carrierId: '',
  requestedRoles:''
};

export const formatRoles = (roles: any = [], selectedRoles: any) => {
  const isCarrierAdmin = roles.indexOf('carrierAdmin') !== -1;
  const defaultRoles = roles.map((role: string) => new EnumType(role));
  const finalRoles = getSelectedRoles(selectedRoles);
  return isCarrierAdmin ? [new EnumType('carrierAdmin'), ...finalRoles] : finalRoles?.length > 0 ? finalRoles : defaultRoles;
}
export const formatRequestedRoles = (roles: any = [], selectedRoles: any) => {
  const isCarrierAdmin = roles.indexOf('carrierAdmin') !== -1;
  const defaultRoles = roles.map(function(item:any) {
    return item['value'];
  });
  const finalRoles = getRequestedRoles(selectedRoles);
  return isCarrierAdmin ? [new EnumType('carrierAdmin'), ...finalRoles] : finalRoles.length > 0 ? finalRoles.toString() : defaultRoles;
}

export const updatedRoles = (roles:any) => { return roles?.map(function(item:any) {
  return item['value'];
});
}

/**
 * Get Selecte Roles with enum type
 * @param roles
 */
export const getSelectedRoles = (roles: Array<IRole>) => {
  return roles?.filter(role => role.selected).map(role => new EnumType(role.value));
};
export const  getRequestedRoles = (roles: Array<IRole>) => {
  var requestdRoles = roles.filter(role => role.selected).map(function(item:any) {
    return item['value'];
  });
  return requestdRoles;
};


/**
 * Get Formatted Address
 * @param value
 */
export const getAddressValue = (value: IAddress) => {
  return value ? `${value.city}${value.state && (', ' + value.state)}`.replace(/(^,)|(,$)/g, "") : "";
};

export const ShowPopup = (props: any) => {
  return props.alertProps ? <CustomModal {...props.alertProps} /> : null
}

export const getFormatedRoles = (user: any, isSelf: boolean) => {
  if (isSelf) {
    const userRole = IONICWrapper.details.auth.user.roles && IONICWrapper.details.auth.user.roles.map((role: any) => ROLES[role]);
    return userRole.join(', ') || '';
  } else {
    return user && user.roles && user.roles.map((role: any) => {
      const selectedOption = rolesList.find((option: any) => option.value === role);
      return selectedOption ? selectedOption.name : '';
    }).join(', ') || '';
  }

}

export const getUserFields = (selectedUser: any, isSelf: boolean = false) => {
  const roles = getFormatedRoles(selectedUser, isSelf) || 'Guest';
  const driverFields = ((selectedUser && selectedUser.roles && selectedUser.roles.indexOf('carrierDriver') !== -1) || isLeasedOwnerOprRoleOnlyOnSelectedUser(selectedUser?.roles) || isElevatedLeasedOwenerOprRoleOnSelectedUser(selectedUser?.roles)) ? [
    {
      label: PROFILE_FIELDS.PARK_LOCATION,
      value: (selectedUser.address && selectedUser.address.length) > 0 ? (getAddressValue(selectedUser.address[0]) || '-') : '-'
    },
    {
      label: PROFILE_FIELDS.TRACKTOR_NUMBER,
      value: selectedUser.tractorNumber || '-'
    },
  ] : [];

  const userProfile: Array<any> = selectedUser ? [
    {
      label: PROFILE_FIELDS.FIRST_NAME,
      value: selectedUser.firstName
    },
    {
      label: PROFILE_FIELDS.LAST_NAME,
      value: selectedUser.lastName
    },
    {
      label: PROFILE_FIELDS.EMAIL_ADDRESS,
      value: selectedUser.email || '-'
    },
    {
      label: PROFILE_FIELDS.MOBILE_NUMBER,
      value: selectedUser.mobileNumber
    },
    {
      label: PROFILE_FIELDS.ROLES,
      value: roles
    },
    ...driverFields,
    {
      label: PROFILE_FIELDS.CARRIER_ID,
      value: selectedUser.carrierId || 'NA'
    },
  ] : [];
  return userProfile && userProfile.length > 0 ? userProfile.map((profile: any) => (
        profile.label !== PROFILE_FIELDS.MOBILE_NUMBER ?
          <IonItem className={`profile-item ${profile.label==="Carrier ID" ? "extra-padding" : ""}`} key={profile.label}>
            <IonLabel className="profile-label" position="floating" mode="ios">{profile.label}</IonLabel>
            <IonInput
              value={profile.value}
              readonly
              type="text"
              class="profile-input"
            ></IonInput>
          </IonItem>
          :
          <IonItem className={`profile-item ${profile.label==="Carrier ID" ? "extra-padding" : ""}`} key={profile.label}>
          <MobileNumber
            mobileNumber={normalizeInput(profile.value)}
            mobileReadOnly={true}
            name="mobileNumber"
            placeholder={''}
            label={profile.label}
            key={profile.label}
            nonEditableField={true}
            countryCodefromMember={removeSpecialProfile(profile.value)?.slice(0, -10)}
          />
          </IonItem>
  )) : null

}
enum CountryCodes {
  USA='+1',
  CANADA='+1',
  MEXICO='+52'
}

export const normalizeInput = (value: any) => {
  if (!value) return value;
  let phone = getOnlyMobileNumber(value);
  const currentValue = phone.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (cvLength < 4) return currentValue;
  if (cvLength < 7) return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
  return `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
};

export const getOnlyMobileNumber = (phone: any) => {
  var mobileNumber:string = "";
  var countryCodesList:any = Object.values(CountryCodes);
  for (var i = 0; i <= countryCodesList.length; i++) {
    mobileNumber = phone.includes(countryCodesList[i]) ? (phone.replace(countryCodesList[i], '')) : phone;
    if (phone.includes(countryCodesList[i])) break;
  }
  return mobileNumber && mobileNumber.replace(/[^0-9]*/g, '');
}
